import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

export interface RepeatStudyCheckPayload {
  reportId?: string;
  patientName?: string;
  dob?: string;
  uhid?: string;
  patientId?: string;
  studyDate?: string;
  studyInstanceUID?: string;
  windowMonths?: number;
}

export interface PriorStudy {
  reportId: string;
  studyInstanceUID: string | null;
  studyType: 'echo' | 'stressEcho';
  studyDate: string;
  monthsAgo: number;
  reportStatus: string | null;
  hospitalId: string | null;
  reportName: string | null;
  matchedBy: 'patientId' | 'name+dob';
}

export interface RepeatStudyCheckResult {
  isRepeat: boolean;
  windowMonths: number;
  referenceDate: string;
  priorStudies: PriorStudy[];
  message: string;
}

export const repeatStudyCheckApi = createAsyncThunk(
  'reports/repeatStudyCheck',
  async (payload: RepeatStudyCheckPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(REPORTS.REPEAT_STUDY_CHECK, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Repeat study check failed: ${response.status}`);
      }
      return (result.result || null) as RepeatStudyCheckResult | null;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
